export default {
    items: [
        {
            name: 'Personal data',
            url: '/user/personal-data/info',
        },
        {
            name: 'Wallets',
            url: '/user/metamask',
        },
        {
            name: 'Transactions',
            url: '/user/transactions/select',
        },
    ]
};



// WEBPACK FOOTER //
// ./src/components/Menu/_nav.js